module.exports = __webpack_public_path__ + "static/media/blendedlearning_desc.76c15264.png";